import { FC } from 'react'
import { useIntl } from 'react-intl'

import { AppointmentModel } from '@models/appointment'

import { BootstrapUtil } from '@modules/appointment/helpers'

import dayjs from '@/libs/dayjs'

type Props = {
  appointment: AppointmentModel
}

const AppointmentAgendaBubble: FC<Props> = ({ appointment }) => {
  const intl = useIntl()

  return (
    <div className="border rounded p-3 mb-3">
      <span className="badge badge-sm badge-light-success me-3">{appointment.code}</span>
      {appointment.status && (
        <span
          className={`badge badge-sm badge-light-${BootstrapUtil.AppointmentStatusSuffixClassName(
            appointment.status
          )} me-3`}
        >
          {intl.formatMessage({ id: `enum.appointment_status.${appointment.status.toLowerCase()}` })}
        </span>
      )}
      <div className="d-flex align-items-center fw-medium mt-1">{appointment.subject}</div>
      <div className="d-flex align-items-center mt-1">
        <div className="w-20px me-1">
          <i className="fa fa-calendar-days fs-5" />
        </div>
        {dayjs(appointment.started_at).defaultFormat()}
      </div>
      {appointment.clinic && (
        <div className="d-flex align-items-center mt-1">
          <div className="w-20px me-1">
            <i className="fas fa-hospital" />
          </div>
          {appointment.clinic.name}
        </div>
      )}
      <div className="d-flex mt-1">
        {appointment.doctor && (
          <div className="d-flex align-items-center me-5">
            <div className="w-20px me-1">
              <i className="fas fa-stethoscope fs-6" />
            </div>
            {appointment.doctor.full_name}
          </div>
        )}
        {appointment.patient && (
          <div className="d-flex align-items-center">
            <div className="w-20px">
              <i className="fas fa-user-injured fs-6" />
            </div>
            {appointment.patient.full_name}
          </div>
        )}
      </div>
    </div>
  )
}

export { AppointmentAgendaBubble }
